let ask = null;

export const registerUnderstandLeave = (handler) => {
  ask = handler;
  return () => {
    if (ask === handler) ask = null;
  };
};

export const requestUnderstandLeave = (proceed) => {
  if (typeof proceed !== 'function') return undefined;
  if (!ask) return proceed();
  return ask(proceed);
};
